import React from "react";
import OrderCta from "./OrderCta";
import "../styles/LocationHero.css";

interface LocationHeroProps {
  locationName: string;
  description: string;
  hours: string;
  address: string;
  phone: string;
  phoneLink: string;
  variant?: "menu" | "location";
}

const LocationHero: React.FC<LocationHeroProps> = ({
  locationName,
  description,
  hours,
  address,
  phone,
  phoneLink,
  variant = "location",
}) => {
  return (
    <section className="location-hero">
      <div className="location-hero-content">
        <div className="location-hero-layout">
          {/* Left Side - Text Info */}
          <div className="location-hero-left">
            <h1 className="location-hero-title">{locationName}</h1>
            <p className="location-hero-description">{description}</p>
            <OrderCta variant={variant} />
          </div>

          {/* Right Side - Business Hours and Address */}
          <div className="location-hero-right location-hero-info-box">
            <div className="location-hero-hours">{hours}</div>
            <div className="location-hero-address">
              {address.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index < address.split("\n").length - 1 && <br />}
                </React.Fragment>
              ))}
            </div>
            <a href={phoneLink} className="location-hero-phone">
              {phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationHero;
